export enum AnalyticsId {
  MATS_EXPLORE = "mats-explore_cta-ab5",
  ASSETS_BRIDGE = "assets-bridge_cta-ab3",
  ASSETS_ADD_FUNDS = "assets-add_funds_cta-ab1",
  MUSD_BORROW = "musd-borrow_cta-ab2",
  ONBOARDING_SIGNIN = "nav-sign_in-nb3",
  ETHEREUM_WALLET = "onboarding-siw_eth_wallet-om1",
  BITCOIN_WALLET = "onboarding-siw_btc_wallet-om2",
  ONBOARDING_SIGNUP = "onboarding-signup-om3",
  TAHO_WALLET = "onboarding-siw_injected-om4",
  METAMASK_WALLET = "onboarding-siw_metamask-om5",
  ZERION_WALLET = "onboarding-siw_zerion-om6",
  OKX_WALLET = "onboarding-siw_okx_eth-om7",
  UNISAT_WALLET = "onboarding-siw_unisat-om8",
  OKX_BTC_WALLET = "onboarding-siw_okx-om9",
  XVERSE_WALLET = "onboarding-siw_xverse-om10",
  VAULT_DEPOSIT_AUGUST = "vault-deposit_august-hb1",
  LEARN_MORE_VAULTS = "learn_more-vaults-hb2",
  VAULT_REVIEW_DEPOSIT = "vault-review_deposit-hm1",
  VAULT_SIGN_DEPOSIT = "vault-sign_deposit_txn-hm2",
  SWAP_COMPLETE = "assets-complete_swap-am2",
  SWAP_REVIEW = "assets-review_swap-am1",
  SWAP_NAVIGATION_BUTTON = "nav-swap-nb4",
}

export enum SegmentEvent {
  ASSETS_SWAPPED = "Asset Swapped",
}
